export class BankingConstants {
  public static BankingLoginRequired = 'Banking credentials login required';
}
